// React
import React from 'react'
import classNames from 'classnames'
// Material UI
import { Drawer } from '@material-ui/core'
// Components
import SideMenuItems from './components/side-menu-items'
// Styles
import useStyles from './SideMenu.styles'

const SideMenu = ({ open, onClose }) => {
  const componentClasses = useStyles()

  return (
    <Drawer
      anchor='left'
      classes={{
        paper: classNames(
          componentClasses.drawerPaper,
          !open && componentClasses.drawerPaperClose,
        ),
      }}
      onClose={onClose}
      open={open}
    >
      <SideMenuItems onClose={onClose} />
    </Drawer>
  )
}

SideMenu.defaultProps = {
  classes: {},
  onClose: () => {},
  open: false,
}

export default SideMenu
